module.exports = __webpack_public_path__ + "img/college8.c33b6f3a.png";